import { createAsyncThunk } from '@reduxjs/toolkit'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { progressService } from '../../services/progressService'
import {
  GET_CONTRACT_SIGNATURE_PROGRESS_DATA,
  GET_LR_PROGRESS_DATA,
  GET_PROFILING_PROGRESS_DATA,
} from '../config'
import {
  IContractSignatureProgressParams,
  ILRProgressParams,
  IProfilingProgressParams,
} from '../models/progressDataModels'
import {
  selectContractSignatureProgressLoadingStatus,
  selectLRProgressLoadingStatus,
  selectProfilingProgressLoadingStatus,
} from '../selectors/selectProgressData'

import { handleApiResponse } from './helpers/handleApiResponse'

class ProgressApi {
  public getProfilingProgress = createAsyncThunk(
    GET_PROFILING_PROGRESS_DATA,
    async ({ partnerId, requestId }: IProfilingProgressParams) => {
      const response = await progressService.fetchProfilingProgress(partnerId, requestId)
      return handleApiResponse(response)
    },
    {
      condition({ partnerId, requestId }, { getState }) {
        if (!partnerId) {
          return false
        }
        if (!requestId) {
          return false
        }

        const state = getState() as any
        const status = selectProfilingProgressLoadingStatus(state)
        if (status === RequestStatus.PENDING) {
          return false
        }

        return
      },
    }
  )

  public getLRProgress = createAsyncThunk(
    GET_LR_PROGRESS_DATA,
    async ({ requestId }: ILRProgressParams) => {
      const response = await progressService.fetchLRProgress(requestId)
      return handleApiResponse(response)
    },
    {
      condition({ requestId }, { getState }) {
        if (!requestId) {
          return false
        }

        const state = getState() as any
        const status = selectLRProgressLoadingStatus(state)
        if (status === RequestStatus.PENDING) {
          return false
        }

        return
      },
    }
  )

  public getContractSignatureProgress = createAsyncThunk(
    GET_CONTRACT_SIGNATURE_PROGRESS_DATA,
    async ({ requestId }: IContractSignatureProgressParams) => {
      const response = await progressService.fetchContractSignatureProgress(requestId)
      return handleApiResponse(response)
    },
    {
      condition({ requestId }, { getState }) {
        if (!requestId) {
          return false
        }

        const state = getState() as any
        const status = selectContractSignatureProgressLoadingStatus(state)
        if (status === RequestStatus.PENDING) {
          return false
        }

        return
      },
    }
  )
}

export const progressApi = new ProgressApi()
